// extracted by mini-css-extract-plugin
export default {"WhatsAppInfoDialog":"+DFbQT4IT4b7IeuxAzxo6g=="};